import React from 'react';

import { Layout } from 'antd';

const { Footer } = Layout;
const AuthFooter: React.FC = () => {
    return (
        <Footer style={{ textAlign: 'center' }}>
            FTC © 2025
        </Footer>
    )
}

export default AuthFooter;